import MyInput from '../../components/ui/MyInput';
import deleteX from '../../assets/img/deleteX.svg';
import { useEffect, useState } from 'react';
import PrimaryButton from '../../components/ui/PrimaryButton';
import {
  SVG_Add_Square_Bold,
  SVG_Traffic_Bold,
  SVG_Trash_Bin_2_Bold,
  SVG_Trash_Bin_2_Linear,
  SVG_Trash_Bin_2_Outline,
  SVG_Trash_Bin_Minimalistic_2_Bold,
} from '@dev-mobligo/iconpack';
import { useDispatch } from 'react-redux';
import systemSlice from '../../redux/systemSlice';
import { useNavigate } from 'react-router-dom';
import allTabs from '../DashboardTabs';
import LayeredDashboardHeader from '../LayeredDashboardHeader';
import CreateAction from '../../components/operational/createAction';
import useCustomNavigate from '../../components/operational/goBack';
import { v4 as uuid } from 'uuid';
import { TreeSelect } from 'primereact/treeselect';
import store from '../../redux/store';
import { useSelector } from 'react-redux';
import Table from '../../components/ui/Table';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import AddLanguage from './AddLanguage';
import countryCodes from '../../utils/countryCodes.json';
import { Dropdown } from 'primereact/dropdown';
import SecondaryButton from '../../components/ui/SecondaryButton';
import ThemeVariantsAddNew from './ThemeVariantsAddNew';
import LayeredDashboardModal from './Modals/LayeredDashboardModal';

const ThemeVariants = ({ tab }) => {
  const navigate = useNavigate();
  const goBack = useCustomNavigate(tab);
  const [themeVariants, setThemeVariants] = useState([]);
  const [isActive, setIsActive] = useState(false);
  const [initialThemeVariant, setInitialThemeVariant] = useState(null);
  const [isEdit, setIsEdit] = useState(false);

  const bodyVariant = rowData => {
    return <div className="flex flex-row flex-wrap min-w-[200px] w-full">{rowData.name}</div>;
  };

  const bodyVariantSettings = rowData => {
    return (
      <div className="flex flex-row flex-wrap w-full justify-end gap-[10px] ">
        {/* {themeVariants?.length > 1 && (
          <SecondaryButton
            confirmationMessage="Tema Varyantını Silmek İstediğinize Emin Misiniz?"
            classes=" border-red-500 text-red-500 hover:bg-red-500 hover:text-white duration-300"
            value={'Sil'}
            onClick={() => {
              deleteThemeVariant(rowData);
            }}
          ></SecondaryButton>
        )} */}
        <PrimaryButton
          onClick={() => {
            setIsEdit(true);
            setInitialThemeVariant(rowData);
            setIsActive(true);
          }}
          value={'Düzenle'}
        ></PrimaryButton>
      </div>
    );
  };

  const deleteThemeVariant = async initialThemeVariant => {
    if (!initialThemeVariant?.code) {
      return;
    }
    const response = await CreateAction({
      method: 'delete',
      path: `/themeVariants/${initialThemeVariant.code}`,
      showPreLoader: true,
      isFileUploading: false,
    });
    if (response.error) return;
    getThemeVariants();
  };

  const getThemeVariants = async () => {
    const response = await CreateAction({
      method: 'get',
      path: `/themeVariants`,
      showPreLoader: true,
      isFileUploading: false,
    });

    if (response?.error) {
      return;
    }
    const responseData = response?.result?.resultData;
    if (!responseData) return;
    const newThemeVariants = responseData?.map(themeVariant => {
      return {
        name: themeVariant?.name,
        code: themeVariant?.id,
      };
    });
    setThemeVariants(newThemeVariants);
    return newThemeVariants;
  };

  useEffect(() => {
    getThemeVariants();
  }, []);
  return (
    <>
      <LayeredDashboardHeader tab={tab}></LayeredDashboardHeader>
      <div className="w-full h-[calc(100dvh-70px)] overflow-auto scrollbar-y-visible">
        <div>
          <div className="p-[20px] flex items-center justify-center 2xl:p-[40px] flex-col max-w-[1120px] mx-auto">
            <div className="bg-white p-[20px] rounded-[10px] 2xl:p-[40px] max-w-[1120px] w-[100%]">
              <div>
                <div
                  className="flex flex-row items-center"
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <div className="flex flex-col ">
                    <div className="text-[#5E5873] text-[18px] font-semibold">Dil ve Çeviriler</div>
                  </div>
                  <div className="">
                    <PrimaryButton
                      value={'Yeni Dil Ekle'}
                      onClick={() => {
                        setIsEdit(false);
                        setIsActive(true);
                      }}
                    ></PrimaryButton>
                  </div>
                </div>
                <div className="mt-5">
                  <DataTable
                    emptyMessage="Kayıt Bulunamadı. "
                    value={themeVariants}
                    tableStyle={{ minWidth: '50rem' }}
                    rowClassName={''}
                  >
                    <Column field="name" header="Dil Adı" body={bodyVariant}></Column>
                    <Column align="right" field="name" header="Dil Ayarları" body={bodyVariantSettings}></Column>
                  </DataTable>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <LayeredDashboardModal isActive={isActive}>
        <ThemeVariantsAddNew
          isEdit={isEdit}
          setInitialThemeVariant={setInitialThemeVariant}
          initialThemeVariant={initialThemeVariant}
          getThemeVariants={getThemeVariants}
          themeVariants={themeVariants}
          setIsActive={setIsActive}
          tab={{
            ...tab,
            activeTabs: [...tab?.activeTabs, 'Yeni Dil Ekle'],
            activeTabTitles: [...tab?.activeTabTitles, 'Yeni Dil Ekle'],
          }}
        ></ThemeVariantsAddNew>
      </LayeredDashboardModal>
    </>
  );
};

export default ThemeVariants;
